<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="8" :sm="12">
            <a-form-item label="保险公司">
              <j-search-select-tag
                placeholder="请选择保险公司"
                v-model="queryParam.insurerNumber"
                dict="biz_insurance_company,name,code">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="6">
            <a-form-item label="业务类型">
              <j-dict-select-tag
                placeholder="请选择业务类型"
                v-model="queryParam.businessType"
                :options ="allBusinessTypeDictOptions">
              </j-dict-select-tag>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="6">
            <a-form-item label="业绩进度" >
              <a-select v-model="queryParam.progress" placeholder = "请选择" allowClear>
                <a-select-option value="10">补录中</a-select-option>
                <a-select-option value="4">已提交</a-select-option>
                <a-select-option value="12">已审核（待推送）</a-select-option>
                <a-select-option value="13">已推送</a-select-option>
                <a-select-option value="14">已开票</a-select-option>
                <a-select-option value="15">已到账</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :md="4" :sm="6">
              <a-form-item label="保单号" >
                <a-input v-model="queryParam.policy" placeholder="请输入保单号"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="6">
              <a-form-item label="车牌号" >
                <a-input v-model="queryParam.car" placeholder="请输入车牌号"></a-input>
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="6">
              <a-form-item label="投保人">
                <a-input placeholder="请录入投保人" v-model="queryParam.insure"/>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="6">
              <a-form-item label="被保人">
                <a-input placeholder="请录入被保险人" v-model="queryParam.insured"/>
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="8">
              <a-form-item label="项目名称">
                <j-dict-select-tag type="list" v-model="queryParam.project" dictCode="bms_project" placeholder="请选择项目"/>
              </a-form-item>
            </a-col>
            <!--<a-col :md="4" :sm="8">
              <a-form-item label="经纪人">
                <j-search-select-tag
                  placeholder="请选择经纪人"
                  v-model="queryParam.createBy"
                  dict="sys_user,realname,username,del_flag=0">
                </j-search-select-tag>
              </a-form-item>
            </a-col>-->
            <a-col :md="6" :sm="6">
              <a-form-item label="险种名称">
                <a-input placeholder="请录入险种名称" v-model="queryParam.insuranceName"/>
              </a-form-item>
            </a-col>
            <!--<a-col :md="4" :sm="8">-->
              <!--<a-form-item label="导入日期">-->
                <!--<j-date placeholder="请选择" v-model="queryParam.createTime"/>-->
              <!--</a-form-item>-->
            <!--</a-col>-->
            <a-col :md="4" :sm="8">
              <a-form-item label="保险起期">
                <j-date placeholder="请选择" v-model="queryParam.insuranceStart"/>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="8">
              <a-form-item label="保险迄期">
                <j-date placeholder="请选择" v-model="queryParam.insuranceEnd"/>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="8">
              <a-form-item label="开票日期">
                <j-date placeholder="请选择" v-model="queryParam.invoiceTime" @change="handleInvoiceTimeChange"/>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="8">
              <a-form-item label="开票编号">
                <a-input placeholder="请输入开票编号" v-model="queryParam.invoiceNumber"/>
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="4" :sm="10">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('业绩补录表')" >导出</a-button>
    </div>
    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="height:40px; margin-bottom: 16px;">
        <span style="float:right;" >金额单位：元</span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <template slot="statusSlot" slot-scope="text, record">
          <span>{{getStatus(record)}}</span>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
          <a-divider v-if="record.status==12" type="vertical"/>
          <a v-if="record.status==12"  @click="handleInvoiceInfo(record)">发票</a><!--v-has="'businessInfoReport:invoice'"-->
        </span>
      </a-table>
    </div>

    <biz-businessinfo-complete-modal ref="modalForm" @ok="modalFormOk"></biz-businessinfo-complete-modal>

    <a-modal ref="invoiceModal" v-if="invoiceModalVisible" :visible.sync="invoiceModalVisible" title="发票信息" @ok="handleOk" @cancel="handleCancel">
      <biz-businessinfo-invoice-form :businessinfoId="businessinfoId">
      </biz-businessinfo-invoice-form>
    </a-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import {getAction} from '@/api/manage'
  import JDate from '@/components/jeecg/JDate'
  import BizBusinessinfoCompleteModal from './modules/BizBusinessinfoCompleteModal'
  import BizBusinessinfoInvoiceForm from './modules/BizBusinessinfoInvoiceForm'
  import { mapGetters } from 'vuex'
  import { AllBusinessTypeDictOptions } from '../enums/businessTypeDictOptions'
  import {BusinessInfoStatus, InvoiceStatus} from '../enums/BusinessDict'

  export default {
    name: 'ThirdPartyBizBusinessinfoReport',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JSearchSelectTag,
      JDate,
      BizBusinessinfoCompleteModal,
      BizBusinessinfoInvoiceForm,
    },
    data () {
      return {
        description: '业绩进度查询',
        hasImportNewDataPermission: false, //导入历史数据按钮权限，单独判断
        invoiceModalVisible:false,
        businessInfoStatus: [],
        invoiceStatus: [],
        allBusinessTypeDictOptions:[],
        businessinfoId:'', //当前选择的id
        modalVisible: false,
        modifyId: '', // 修改文件的单据id
        fileList: '', //文件列表字符串
        brokerageTotal: 0.0, // 合计
        cleanPremiumTotal: 0.0,
        premiumTotal: 0.0,
        isorter:{
          column: 'createTime',
          order: 'desc',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'业绩编号',
            className:'column-text',
            dataIndex: 'businessNumber',
            sorter: true
          },
          {
            title:'业绩进度',
            align:"center",
            scopedSlots: { customRender: 'statusSlot' }
          },
          {
            title:'开票编号',
            className:'column-text',
            dataIndex: 'invoiceNumber'
          },
          {
            title:'开票日期',
            className:'column-text',
            dataIndex: 'invoiceTime',
            sorter: true
          },
          {
            title:'业务类型',
            align:"center",
            dataIndex: 'businessType_dictText'
          },
          // {
          //   title:'财产险/人身险',
          //   align:"center",
          //   dataIndex: 'productOrLife_dictText'
          // },
          // {
          //   title:'业绩类型',
          //   align:"center",
          //   dataIndex: 'businessPerformanceType_dictText'
          // },
          {
            title:'项目',
            className:"column-text",
            dataIndex: 'project_dictText'
          },
          {
            title:'经纪人',
            align:"center",
            dataIndex: 'createBy_dictText',
            sorter: true
          },
          // {
          //   title:'部门',
          //   className:"column-text",
          //   dataIndex: 'sysOrgCode_dictText',
          //   sorter: true
          // },
          {
            title:'投保人',
            className:"column-text",
            dataIndex: 'insure'
          },
          {
            title:'被保险人',
            className:"column-text",
            dataIndex: 'insured'
          },
          {
            title:'保险人',
            className:"column-text",
            dataIndex: 'insurerNumber_dictText'
          },
          {
            title:'险种类型',
            className:"column-text",
            dataIndex: 'insuranceType_dictText'
          },
          {
            title:'险种名称',
            className:"column-text",
            dataIndex: 'insuranceName'
          },
          {
            title:'车牌号',
            className:'column-text',
            dataIndex: 'car'
          },
          {
            title:'保险起期',
            className:"column-text",
            dataIndex: 'insuranceStart',
            sorter: true,
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'保险讫期',
            className:'column-text',
            dataIndex: 'insuranceEnd',
            sorter: true,
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'保单号',
            className:'column-text',
            dataIndex: 'policy',
            sorter: true
          },
          {
            title:'保额',
            className:'column-money',
            dataIndex: 'insuredAmount',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'费率',
            className:'column-money',
            dataIndex: 'rate',
            customRender:function (text) {
              return !text ? '': text + '‰'
            }
          },
          {
            title:'保费',
            className:'column-money',
            dataIndex: 'premium',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'去税保费',
            className:'column-money',
            dataIndex: 'cleanPremium',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'是否含税',
            align:"center",
            dataIndex: 'includeTax_dictText'
          },
          {
            title:'缴费类型',
            align:"center",
            dataIndex: 'lifeInsurancePayType_dictText'
          },
          {
            title:'佣金比例',
            className:'column-money',
            dataIndex: 'brokerageRatio',
            customRender:function (text) {
              return text == null? '': text + '%'
            }
          },
          {
            title:'总佣金',
            className:'column-money',
            dataIndex: 'brokerageTotal',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'票外金额',
            //align:"center",
            className:'column-money',
            dataIndex: 'outsideInvoiceAmount',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },/*V10*/
          {
            title:'开票单位', //九安、 九安分公司
            className:'column-text',
            dataIndex: 'invoiceUnit_dictText',
          },
          {
            title:'期数',
            align:"center",
            dataIndex: 'phase'
          },
          {
            title:'创建日期',
            className:'column-text',
            dataIndex: 'createTime'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:120,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/bms/bizBusinessinfoComplete/report",
          exportXlsUrl:'/bms/bizBusinessinfoComplete/exportXls',
        },
      }
    },
    created() {
      this.allBusinessTypeDictOptions = AllBusinessTypeDictOptions
      this.businessInfoStatus = BusinessInfoStatus
      this.invoiceStatus = InvoiceStatus
    },
    methods: {
      ...mapGetters(["userInfo"]),
      getStatus(record){
        // 发票状态 0 未推送 1已推送 2 已开票 3已到账
        // 业绩状态 10补录中 4待审核 12已审核 （已生成发票）2023-01-29: 状态后续仍然需调整

        if(record.status == this.businessInfoStatus.UNFIX){
          return "补录中"
        } else if(record.status == this.businessInfoStatus.SUBMIT) {
          return "已提交"
        }else if(record.status == this.businessInfoStatus.READY){
          return "已确认"
        } else if(record.status == this.businessInfoStatus.PASS){
          if( record.invoiceStatus == this.invoiceStatus.NOT_SEND){
            return "待推送"
          } else if(record.invoiceStatus == this.invoiceStatus.SENT){
            return "已推送"
          } else if(record.invoiceStatus == this.invoiceStatus.INVOICED){
            return "已开票"
          } else if(record.invoiceStatus == this.invoiceStatus.PAYED){
            return "已到账"
          }
        }
      },
      getQueryParams() {
        var param = Object.assign({}, this.queryParam, this.isorter ,this.filters)
        // 导入日期
        // if(param.createTime){
        //   param.createTime_begin = param.createTime + ' 00:00:00'
        //   param.createTime_end = param.createTime + ' 23:59:59'
        //   delete param.createTime
        // }
        //保险起期
        if(param.insuranceStart){
          param.insuranceStart_begin = param.insuranceStart + ' 00:00:00'
          param.insuranceStart_end = param.insuranceStart + ' 23:59:59'
          delete param.insuranceStart
        }

        if(param.insuranceEnd){
          param.insuranceEnd_begin = param.insuranceEnd + ' 00:00:00'
          param.insuranceEnd_end = param.insuranceEnd + ' 23:59:59'
          delete param.insuranceEnd
        }
        // 开票日期
        if(param.invoiceTime){
          param.invoiceTime_begin = param.invoiceTime + ' 00:00:00'
          param.invoiceTime_end = param.invoiceTime + ' 23:59:59'
          delete param.invoiceTime
        }
        // 进度处理
        if(param.progress){
          if(param.progress < 12){
            param.status = param.progress
            param.invoiceStatus = null
          } else {
            param.status = 12
            param.invoiceStatus = param.progress - 12 //减去12后值为0，1，2，3对应发票状态值
          }
          delete param.progress
        }
        param.pageNo = this.ipagination.current
        param.pageSize = this.ipagination.pageSize
        return filterObj(param);
      },
      loadData(arg) {
        if (arg == 1) {
          this.ipagination.current = 1
        }
        let params = this.getQueryParams();
        this.loading = true
        let url = `${this.url.list}`
        getAction(url, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },

      handleInvoiceTimeChange(event){
        if(event){
          this.queryParam.progress = undefined; // 清空进度
        }
      },
      // 发票
      handleInvoiceInfo(record){
        this.businessinfoId = record.id
        this.invoiceModalVisible = true
      },
      handleCancel(){
        this.$nextTick(()=> {
          this.invoiceModalVisible = false
        })
      },
      handleOk(){
        this.$nextTick(()=> {
          this.invoiceModalVisible = false
        })
      },

    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>